import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import './index.scss';

@Component
export default class DTCheckbox extends Vue {

  @Prop({ required: true }) checked;
  @Prop({ required: true }) id;
  @Prop({ required: true }) label;
  @Prop({ type: String, default: '39px' }) h;
  @Prop({ type: String, default: 'inherit' }) minH;

  onCheckboxClick(event) {
    this.$emit('click', event);
  }
 

  render(h) {
    return <div class="dt-checkbox-control ut-flex" style={{
      height: this.h,
      minHeight: this.minH,
    }}>
      <div class="dt-checkbox-container">
        <div class="dt-checkbox v2 s1">
          <input
            type="checkbox"
            onClick={this.onCheckboxClick}
            name={this.id}
            id={this.id}
            checked={this.checked}
          />
          <div class="checkmark"></div>
        </div>
      </div>
      {(this.label && this.label.length > 0) && <div class="dt-checkbox-label-container">
        <div class="dt-checkbox-label">
          {this.label}
        </div>
      </div>}
    </div>
  }
}